/* PD search overlay (the app's .fps-full, dressed by the theme):
   · opening fades the page out behind it — no spinner, just the overlay
   · the panel and the search bar animate in
   · the "no results" state gets categories that match what was actually typed, taken from the
     sidebar's own category menu instead of a fixed list.
   Everything here is presentation on top of the app's markup; the app owns the search itself. */
(function () {
  var OPEN = "fps-full-open";
  function cats() {   // our own categories: name + url, from the rail
    var out = [];
    document.querySelectorAll(".pd-rail__cat[href], .pd-rail__sublink[href]").forEach(function (a) {
      var name = (a.querySelector(".pd-rail__name") || a).textContent.replace(/\s+/g, " ").trim();
      /* the tile image: a top category's own, a sub-collection's parent's — same rule as the app */
      var item = a.closest(".pd-rail__item"), img = item && item.querySelector(":scope > .pd-rail__row .pd-rail__cat img");
      if (name && a.getAttribute("href")) out.push({ name: name, url: a.getAttribute("href"), img: img ? (img.currentSrc || img.getAttribute("src") || "") : "" });
    });
    return out;
  }
  function prefix(a, b) { var i = 0, m = Math.min(a.length, b.length); while (i < m && a.charCodeAt(i) === b.charCodeAt(i)) i++; return i; }
  function score(name, tokens) {
    var n = name.toLowerCase(), words = n.split(/[^a-zæøå0-9]+/).filter(Boolean), s = 0;
    tokens.forEach(function (t) {
      if (!t) return;
      if (n === t) { s += 10; return; }
      if (n.indexOf(t) > -1) { s += 6; return; }                                  /* "bremse" in "bremseklodser & sko" */
      var best = 0;
      words.forEach(function (w) {
        if (w.length < 3) return;
        if (t.indexOf(w) > -1) best = Math.max(best, 5);                          /* the typo contains the word */
        var pfx = prefix(w, t);
        if (pfx >= 5) best = Math.max(best, 4);                                   /* "bremseklodserxyz" ~ "bremseklodser" */
        else if (pfx >= 4) best = Math.max(best, 2);
      });
      s += best;
    });
    return s;
  }
  function relevant(query) {
    var tokens = String(query || "").toLowerCase().split(/[^a-zæøå0-9]+/).filter(function (t) { return t.length > 2; });
    if (!tokens.length) return [];
    var scored = cats().map(function (c) { return { c: c, s: score(c.name, tokens) }; }).filter(function (x) { return x.s > 0; });
    scored.sort(function (a, b) { return b.s - a.s || a.c.name.length - b.c.name.length; });
    var seen = {}, out = [];
    scored.forEach(function (x) { var k = x.c.url; if (seen[k]) return; seen[k] = 1; if (out.length < 6) out.push(x.c); });
    return out;
  }
  function dressEmpty(root) {
    var box = root.querySelector(".fps-full__empty"); if (!box || box.dataset.pdDressed) return;
    /* the typed text: the app keeps its own inputs in sync, and the empty state prints the query in
       quotes — read the title first, it is the one place that is always right */
    var title = box.querySelector(".fps-full__empty-title");
    var m = title && title.textContent.match(/[“"']([^”"']+)[”"']/);
    var typed = (m && m[1]) || (root.querySelector("[data-fps-finput]") || {}).value || (document.querySelector(".header .fps__input") || {}).value || "";
    var list = relevant(typed);
    if (!list.length) return;                       /* nothing of ours matched: keep the app's own links */
    var links = box.querySelector(".fps-full__poplinks"); if (!links) return;
    box.dataset.pdDressed = "1";
    links.innerHTML = "";
    list.forEach(function (c) { var a = document.createElement("a"); a.className = "fps-full__poplink"; a.href = c.url; a.textContent = c.name; links.appendChild(a); });
  }
  /* The overlay's "popular categories" list is the app's own fixed set. Before anything is typed,
     replace it with the REAL categories from our sidebar (top level only, in the sidebar's order).
     Recognised by having no result counts — the facet list that appears with results does. */
  var CATS_KEY = "pd_cats";
  function topCats() {
    var out = [], seen = {};
    document.querySelectorAll(".pd-rail__cat[href]").forEach(function (a) {
      var name = (a.querySelector(".pd-rail__name") || a).textContent.replace(/\s+/g, " ").trim();
      var url = a.getAttribute("href"), img = a.querySelector("img");
      if (!name || !url || seen[url]) return; seen[url] = 1;
      out.push({ name: name, url: url, img: img ? (img.currentSrc || img.getAttribute("src") || "") : "" });
    });
    out = out.slice(0, 10);   /* the merchant wants ten, no more, and no scrollbar */
    /* remembered, so pages without the sidebar (cart, 404) still show OUR categories */
    try { if (out.length) localStorage.setItem(CATS_KEY, JSON.stringify(out)); else out = JSON.parse(localStorage.getItem(CATS_KEY) || "[]"); } catch (e) {}
    return out;
  }
  function dressSide(root) {
    var side = root.querySelector(".fps-full__side"); if (!side) return;
    var list = side.querySelector(".fps-full__sidelist"); if (!list) return;
    /* The app says what its rail is showing (data-fps-facets = live | fallback | none). "live" = real
       search facets with counts: leave them alone. Detecting that by the presence of a count class
       broke the moment the app renamed it (2026-09-18 — every render of the new tile rail was wiped
       and replaced with this list, "den loader ind med den nye men forsvinder"). The class check stays
       only as a fallback for an app build that predates the attribute. */
    if (side.dataset.fpsFacets === "live") return;
    var counted = Array.prototype.some.call(list.querySelectorAll(".fps-full__sidecount, .fps-full__tilecount"), function (c) { return (c.textContent || "").trim(); });
    if (counted) return;                                        /* real search facets: leave them alone */
    var cs = topCats(); if (!cs.length) return;
    /* compare instead of trusting a flag: the app re-renders its own list whenever the query is
       cleared, and a sticky flag made us skip it (the merchant kept seeing the app's five) */
    var now = Array.prototype.map.call(list.querySelectorAll(".fps-full__tilename, .fps-full__sidename, .fps-full__sidelink"), function (e) { return e.textContent.trim(); }).join("|");
    var ours = cs.map(function (c) { return c.name; }).join("|");
    if (now === ours) return;
    list.innerHTML = "";
    /* same tile markup + classes as the app's own rail, so the two never look like two designs */
    cs.forEach(function (c) {
      var li = document.createElement("li");
      var a = document.createElement("a"); a.className = "fps-full__tile"; a.href = c.url;
      var ic = document.createElement("span"); ic.className = "fps-full__tileicon";
      if (c.img) { var im = document.createElement("img"); im.src = c.img; im.alt = ""; im.loading = "lazy"; im.width = 32; im.height = 32; ic.appendChild(im); }
      var n = document.createElement("span"); n.className = "fps-full__tilename"; n.textContent = c.name;
      a.appendChild(ic); a.appendChild(n); li.appendChild(a); list.appendChild(li);
    });
  }
  /* ONE debounced observer for the whole file, scoped to the body and to childList only.
     The earlier version watched documentElement WITH attributes and mutated the DOM inside the
     callback — every class change on the page (animations, the app's own updates) re-entered it, and
     rewriting the category list could ping-pong with the app forever: the tab spun and the shop froze. */
  var tries = 0, pending = 0;
  function pass() {
    pending = 0;
    var root = document.querySelector(".fps-full");
    if (!root) { guard(); return; }
    if (!root.dataset.pdSearchInit) {
      root.dataset.pdSearchInit = "1";
      var input = root.querySelector("[data-fps-finput]");
      if (input) input.addEventListener("input", function () { tries = 0; var b = root.querySelector(".fps-full__empty"); if (b) delete b.dataset.pdDressed; });
    }
    if (tries < 40) { tries++; try { dressEmpty(root); dressSide(root); } catch (e) {} }
    guard();
  }
  function schedule() { if (pending) return; pending = setTimeout(pass, 120); }
  /* safety net: if the overlay is gone (or hidden) while the body still says it is open, the page
     would sit faded out — drop the class so the shop can never be left unusable */
  function guard() {
    if (!document.body.classList.contains(OPEN)) return;
    var el = document.querySelector(".fps-full");
    var open = el && el.offsetParent !== null && getComputedStyle(el).visibility !== "hidden";
    if (!open) document.body.classList.remove(OPEN);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener("focusin", function (e) { if (e.target.closest(".fps, .fps-full, .header__search")) { tries = 0; schedule(); } });
  setInterval(guard, 1500);
  pass();
})();